import { CheckCircle, Archive, Pause, AlertCircle } from 'lucide-react'

interface StatusBadgeProps {
  status?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const StatusBadge = ({ status, size = 'md', className = '' }: StatusBadgeProps) => {
  // Determine the actual status and display properties
  const getStatusProps = (status?: string) => {
    const normalizedStatus = status?.toLowerCase()
    
    switch (normalizedStatus) {
      case 'active':
      case 'published':
      case undefined:
      case null:
        return {
          text: 'Published',
          icon: CheckCircle,
          className: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-400'
        }
      
      case 'archived':
        return {
          text: 'Archived',
          icon: Archive,
          className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
        }
      
      case 'suspended':
      case 'paused':
        return {
          text: 'Suspended',
          icon: Pause,
          className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-400'
        }
      
      case 'draft':
      case 'inactive':
        return {
          text: 'Draft',
          icon: AlertCircle,
          className: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-400'
        }
      
      default:
        return {
          text: status || 'Unknown',
          icon: AlertCircle,
          className: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400'
        }
    }
  }

  const { text, icon: Icon, className: statusClassName } = getStatusProps(status)

  // Size variations
  const sizeClasses = {
    sm: {
      container: 'px-2 py-1 text-xs',
      icon: 'w-3 h-3 mr-1'
    },
    md: {
      container: 'px-2 py-1 text-xs',
      icon: 'w-3 h-3 mr-1'
    },
    lg: {
      container: 'px-3 py-1 text-sm',
      icon: 'w-4 h-4 mr-1.5'
    }
  }

  const sizeConfig = sizeClasses[size]

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${statusClassName} ${sizeConfig.container} ${className}`}>
      <Icon className={sizeConfig.icon} />
      {text}
    </span>
  )
}

export default StatusBadge 